import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  alpha,
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';
import { useMatch, useResolvedPath } from 'react-router-dom';
import { useSidebarExpanded } from '../sidebar.context';
import { listItemStyle } from '../sidebar-link/sidebar-link.styles';

const SidebarSection = ({
  title = () => null,
  icon,
  to,
  children,
  onClose,
}) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: false });
  const [open, setOpen] = useState(!!match);
  const expanded = useSidebarExpanded();
  const handleClick = () => {
    setOpen(!open);
  };

  const titleText = title();

  return (
    children?.length > 0 && (
      <Box data-testid="SidebarSection.Box">
        <Tooltip title={!expanded ? titleText : ''} placement="right">
          <ListItemButton
            onClick={handleClick}
            sx={{
              ...listItemStyle,
              justifyContent: expanded ? 'initial' : 'center',
              pr: 1,
            }}
            selected={!expanded && !!match}
            data-testid="SidebarSection.ListItemButton"
          >
            {!!icon && (
              <ListItemIcon
                sx={theme => ({
                  color: alpha(theme.palette.common.white, 0.82),
                  minWidth: 0,
                  justifyContent: 'center',
                  marginRight: expanded ? 1 : 0,
                })}
              >
                {icon}
              </ListItemIcon>
            )}
            {expanded && !!title && (
              <ListItemText
                data-testid="SidebarSection.ListItemText"
                primary={titleText}
              />
            )}
            {expanded && (open ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </Tooltip>
        <Collapse in={open && expanded} timeout="auto" unmountOnExit={false}>
          <List component="div" disablePadding dense>
            {children.map((node, i) => (
              <node.component
                {...node}
                key={`${node.title}${i}`}
                onClose={onClose}
              />
            ))}
          </List>
        </Collapse>
      </Box>
    )
  );
};

export default SidebarSection;
